
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

// The list of menu items for reference when determining page titles
interface MenuItem {
  title: string;
  path: string;
}

const menuItems: MenuItem[] = [
  { title: "Dashboard", path: "/dashboard" },
  { title: "Orders Decoprof", path: "/orders" },
  { title: "Orders Luijten VVZ", path: "/orders/luijten-vvz" },
  { title: "Voorraad", path: "/inventory" },
  { title: "Kleurcontrole", path: "/color-check" },
  { title: "Meldingen", path: "/notifications" },
  { title: "Rapportages", path: "/reports" },
  { title: "Medewerkers", path: "/medewerkers" },
  { title: "Rollenbeheer", path: "/rollenbeheer" },
  { title: "Nieuws+", path: "/modal-campagnes" },
];

export function usePageTitle(): string {
  const location = useLocation();
  const [pageTitle, setPageTitle] = useState("Luijten VVZ");
  
  useEffect(() => {
    const currentPath = location.pathname;
    
    // Special case for notification detail
    if (currentPath.includes('/notification-detail/')) {
      setPageTitle("Melding Details");
      return;
    }
    
    // Find matching menu item for the current path
    const matchingItem = menuItems.find(item => 
      currentPath === item.path || currentPath.startsWith(`${item.path}/`)
    );
    
    if (matchingItem) {
      setPageTitle(matchingItem.title);
    } else {
      setPageTitle("Luijten VVZ");
    }
  }, [location]);

  return pageTitle;
}
